import { isUndefined } from 'lodash-es'
import { BillingPeriod } from '@common/constants'
import { getPrice } from './volume-components-helpers'

export enum UsagePriceTypes {
    PayGo,
    FlatRate,
    None,
}

export const getUsagePriceType = (allPrices: Record<string, Record<number, number>>, usagePrice?: number) => {
    if (!isUndefined(usagePrice)) {
        const price = getPrice(1, allPrices[BillingPeriod.MONTHLY]!)
        if (price === 0) return UsagePriceTypes.PayGo
        return UsagePriceTypes.FlatRate
    }
    return UsagePriceTypes.None
}

export const isNoneUsagePrice = (value: UsagePriceTypes) => value === UsagePriceTypes.None
export const isPayGoUsagePrice = (value: UsagePriceTypes) => value === UsagePriceTypes.PayGo
export const isFlatRateUsagePrice = (value: UsagePriceTypes) => value === UsagePriceTypes.FlatRate
